export default function () {
  return [
    {
      title: 'Warnings',
      to: '/dashboard/warnings',
      htmlBefore: '<i class="material-icons">warning</i>'
    },
    {
      title: 'Geneva Monitoring',
      to: '/dashboard/monitoring',
      htmlBefore: '<i class="material-icons">dvr</i>'
    },
    {
      title: 'Trips',
      to: '/dashboard/trips',
      htmlBefore: '<i class="material-icons">card_travel</i>'
    },
    {
      title: 'Slot summary',
      to: '/dashboard/slots',
      htmlBefore: '<i class="material-icons">view_timeline</i>'
    },
    {
      title: 'Aircrafts',
      to: '/dashboard/aircrafts',
      htmlBefore: '<i class="material-icons">local_airport</i>'
    },
    {
      title: 'Airports',
      to: '/dashboard/airports',
      htmlBefore: '<i class="material-icons">flight_takeoff</i>'
    },
    {
      title: 'Agents / Handlers',
      to: '/dashboard/agents',
      htmlBefore: '<i class="material-icons">business_center</i>'
    },
    {
      title: 'Hotels',
      to: '/dashboard/hotels',
      htmlBefore: '<i class="material-icons">local_hotel</i>'
    },
    {
      title: 'Customers',
      to: '/dashboard/customers',
      htmlBefore: '<i class="material-icons">work</i>'
    },
    {
      title: 'Crew',
      to: '/dashboard/crew',
      htmlBefore: '<i class="material-icons">face</i>'
    },
    {
      title: 'Passengers',
      to: '/dashboard/passengers',
      htmlBefore: '<i class="material-icons">airline_seat_recline_normal</i>'
    },
    {
      title: 'Countries',
      to: '/dashboard/countries',
      htmlBefore: '<i class="material-icons">language</i>'
    },
    {
      title: 'Checklist templates',
      to: '/dashboard/checklist-templates',
      htmlBefore: '<i class="material-icons">playlist_add_check</i>'
    },
    {
      title: 'Users',
      to: '/dashboard/users',
      htmlBefore: '<i class="material-icons">people</i>',
      permissions: ['ADMIN']
    },
    {
      title: 'Document scanner',
      to: '/dashboard/document-scanner',
      htmlBefore: '<i class="material-icons">document_scanner</i>'
    },
    {
      title: 'Settings',
      to: '/dashboard/settings',
      htmlBefore: '<i class="material-icons">settings</i>'
    },
    {
      title: 'Notifications',
      to: '/dashboard/notifications',
      htmlBefore: '<i class="material-icons">notifications</i>'
    },
    {
      title: 'Logout',
      to: '/logout',
      htmlBefore: '<i class="material-icons">power_settings_new</i>'
    }
  ];
}
